import React from "react"
import PropTypes from "prop-types"
import useHover from "../../hooks/useHover"

const FilterCategory = ({
  name,
  isCurrentCategory,
  setFilterCategoryName,
  setCurrentPage,
}) => {
  const [hoverRef, isHovered] = useHover()

  return (
    <button
      value={name}
      ref={hoverRef}
      onClick={e => {
        setFilterCategoryName(e.currentTarget.value)
        setCurrentPage(1)
      }}
      className="relative"
      type="button"
    >
      <p
        className={`text-lg !leading-normal tracking-wide pr-4 sm:text-2xl ${
          isHovered || isCurrentCategory ? "text-amber-400" : "text-neutral-500"
        }`}
      >
        {name}
      </p>
    </button>
  )
}

FilterCategory.propTypes = {
  name: PropTypes.string,
  isCurrentCategory: PropTypes.bool,
  setFilterCategoryName: PropTypes.func,
  setCurrentPage: PropTypes.func,
}

export default FilterCategory
